import { useEffect, useState } from "react";
import { request, requestFileAPI } from "./network/Request";

export const Manage = () => {
  const [selectedCompany, setSelectedCompany] = useState({});
  const [companyList, setCompanyList] = useState([]);
  const [ci, setCI] = useState({});
  const [thumbnail, setThumbnail] = useState({});
  const [image, setImage] = useState({});
  const [orderUpdating, setOrderUpdating] = useState(false);

  useEffect(() => {
    requestCompanyList();
  }, []);

  const requestCompanyList = () => {
    request({ "bk-working": "company-list" }, (result, response) => {
      if (result) {
        setCompanyList(response["company_list"]);
        console.log(response);
      }
    });
  }

  const commitCompany = () => {
    var work;
    if (!selectedCompany["company_id"]) {
      work = "insert-company";
    } else {
      work = "edit-company";
    }

    request({ ...selectedCompany, "bk-working": work }, (result, response) => {
      alert(result);

      let companyId = selectedCompany["company_id"] ?? response["company_id"];

      if (ci?.file) {
        requestFileAPI(
          {
            "bk-working": "edit-company-image",
            company_id: companyId,
            type: "ci",
          },
          [ci.file],
          (result, response) => {
            alert(result ? "CI 등록완료" : "CI 등록 실패");
          }
        );
      }
      if (thumbnail?.file) {
        requestFileAPI(
          {
            "bk-working": "edit-company-image",
            company_id: companyId,
            type: "thumbnail_image",
          },
          [thumbnail.file],
          (result, response) => {
            alert(result ? "썸네일 등록완료" : "썸네일 등록 실패");
          }
        );
      }
      if (image?.file) {
        requestFileAPI(
          {
            "bk-working": "edit-company-image",
            company_id: companyId,
            type: "detail_image",
          },
          [image.file],
          (result, response) => {
            alert(result ? "상세이미지 등록완료" : "상세이미지 등록 실패");
          }
        );
      }
    });
  };

  const edit = (field, value) => {
    setSelectedCompany({ ...selectedCompany, [field]: value });
  };

  const createField = (field, placeHolder) => {
    return (
      <div>
        {placeHolder}
        <input
          value={selectedCompany[[field]] ?? ""}
          onChange={(e) => edit(field, e.target.value)}
        />
      </div>
    );
  };

  const loadImage = (e, callback) => {
    e.preventDefault();
    const fileReader = new FileReader();
    if (e.target.files[0]) {
      fileReader.readAsDataURL(e.target.files[0]);
    } else {
      alert("선택된 파일이 없습니다");
      return;
    }

    fileReader.onload = () => {
      callback({
        file: e.target.files[0],
        previewUrl: fileReader.result,
      });
    };
  };

  const imageField = (url, fileJSON, onChange) => (
    <div>
      <img src={fileJSON.previewUrl ?? url} />
      <input type="file" accept="image/*" onChange={onChange} />
    </div>
  );

  const deleteSelectedCompany = (company) => {
    if (window.confirm("정말 삭제하시겠습니까?")) {
      request(
        {
          "bk-working": "delete-company",
          company_id: company["company_id"],
          company_order: company["company_order"],
        },
        (result, response) => {
          setCompanyList([]);
          requestCompanyList();
        }
      );
    }
  };

  const changeOrder = (companyId, newOrder, pastOrder) => {
    if (orderUpdating) {
      alert("업데이트 중입니다. 새로고침 후 다시 시도해주세요.");
      return;
    }
    setOrderUpdating(true);
    request(
      {
        "bk-working": "edit-company-order",
        company_id: companyId,
        company_order: newOrder,
        past_order: pastOrder,
      },
      (result, response) => {
        if (result) {
          setOrderUpdating(false);
          setCompanyList([]);
          requestCompanyList();
        }
      }
    );
  };

  return (
    <>
      <button onClick={() => setSelectedCompany({})}>신규</button>
      <div style={{ height: "700px", overflowY: "scroll" }}>
        <table>
          <thead>
            <tr>
              <th width="8%">이름</th>
              <th width="8%">카테고리</th>
              <th width="10%">주소</th>
              <th width="7%">연락처</th>
              <th width="7%">웹</th>
              <th width="7%">제품</th>
              <th width="7%">이메일</th>
              <th width="7%">CI</th>
              <th width="9%">썸네일</th>
              <th width="9%">이미지</th>
              <th width="7%">순서</th>
              <th width="7%">수정</th>
              <th width="7%">삭제</th>
            </tr>
          </thead>
          <tbody>
            {companyList.map((item, index) => (
              <tr key={item["company_id"]}>
                <td>{item["company_name"]}</td>
                <td>{item["category"]}</td>
                <td>{item["address"]}</td>
                <td>{item["phone"]}</td>
                <td>{item["web"]}</td>
                <td>{item["main_product"]}</td>
                <td>{item["email"]}</td>
                <td>
                  <img width={30} height={30} src={item["ci"]} />
                </td>
                <td>
                  <img width={30} height={30} src={item["thumbnail_image"]} />
                </td>
                <td>
                  <img width={30} height={30} src={item["detail_image"]} />
                </td>
                <td>
                  <input
                    type="text"
                    defaultValue={[item["company_order"]]}
                    onChange={(e) => (item["new_order"] = e.target.value)}
                  />
                  <button
                    disabled={orderUpdating}
                    onClick={(e) =>
                      changeOrder(
                        item["company_id"],
                        item["new_order"],
                        item["company_order"]
                      )
                    }
                  >
                    변경
                  </button>
                </td>
                <td>
                  <button onClick={() => setSelectedCompany(item)}>수정</button>
                </td>
                <td>
                  <button onClick={() => deleteSelectedCompany(item)}>
                    삭제
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      추가/수정 아이디:{selectedCompany["company_id"] ?? "신규"}
      {createField("company_name", "이름")}
      {createField("category", "카테고리")}
      {createField("address", "주소")}
      {createField("phone", "연락처")}
      {createField("email", "이메일")}
      {createField("main_product", "주생산품")}
      {createField("web", "홈페이지(https, http 포함)")}
      CI
      <br />
      {imageField(selectedCompany["ci"], ci, (e) =>
        loadImage(e, (fileJSON) => setCI(fileJSON))
      )}
      썸네일
      <br />
      {imageField(selectedCompany["thumbnail_image"], thumbnail, (e) =>
        loadImage(e, (fileJSON) => setThumbnail(fileJSON))
      )}
      이미지
      <br />
      {imageField(selectedCompany["detail_image"], image, (e) =>
        loadImage(e, (fileJSON) => setImage(fileJSON))
      )}
      <input type="button" value="제출" onClick={commitCompany} />
      <img />
    </>
  );
};
